import { render, staticRenderFns } from "./AffiliateRenewalSignature.vue?vue&type=template&id=1caceefa"
import script from "./AffiliateRenewalSignature.vue?vue&type=script&lang=ts"
export * from "./AffiliateRenewalSignature.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports